module.exports = __webpack_public_path__ + "static/media/icon-webinar.247c1823.svg";